import { z } from "zod/v4";

import { ProcessStatusTableDtoSchema } from "../../../dtos/processes";

export const GetProcessesResponseBodySchema = z.object({
  processes: ProcessStatusTableDtoSchema.array(),
});

export type GetProcessesResponseBodyType = z.infer<
  typeof GetProcessesResponseBodySchema
>;
